module.exports = __webpack_public_path__ + "img/LogoDashboard-7.7e5a1088.svg";